import { MouseEventHandler } from "react"

import {
  Button,
  ButtonMode,
} from "../../../../../components/base/control/Button"
import { classNames } from "../../../../../lib/classNames"

interface DragHandleProps {
  onMouseDown: MouseEventHandler<HTMLButtonElement>
}

export function DragHandle({ onMouseDown }: DragHandleProps) {
  return (
    <Button
      mode={ButtonMode.Secondary}
      onMouseDown={onMouseDown}
      className={classNames(
        "absolute left-1/2 top-[1.5px] -translate-x-1/2",
        "h-auto px-1 py-0.5",
        "group-hover:animate-enter opacity-0 group-hover:opacity-100",
        "cursor-grab active:cursor-grabbing"
      )}
    >
      <DotGrid />
    </Button>
  )
}

function DotGrid() {
  return (
    <div className="flex gap-0.5">
      {[...Array(3)].map((_, i) => (
        <div key={i} className="flex flex-col gap-0.5">
          {[...Array(2)].map((_, j) => (
            <Dot key={j} />
          ))}
        </div>
      ))}
    </div>
  )
}

function Dot() {
  return (
    <div className="color-icon-subtle h-0.5 w-0.5 rounded-full bg-current" />
  )
}
